import { Request } from '../request';
import type { BillingPolicy, ConsentForm, ApiPracticeProfile, BusinessInfo, PayoutAccount } from 'types/paymentSetup';

export const getBillingPolicy = () => Request.get({ url: '/schedule-server/provider/appointment/policy/list' });

export const getBillingPolicyByOps = (providerId: number) => Request.get({ url: `/admin-server/provider/appointment/policy/list/${providerId}` });

export const getConsentForm = () => Request.get({ url: '/schedule-server/provider/consent/form/list' });

export const getConsentFormByOps = (providerId: number) => Request.get({ url: `/admin-server/provider/consent/form/list/${providerId}` });

export const getPracticeProfile = () => Request.post({ url: '/schedule-server/provider/profile/detail', params: { step: 'PRACTICE' } });

export const getBusinessInfo = () => Request.get({ url: '/schedule-server/provider/business/info/detail' });

export const getPayoutAccount = () => Request.get({ url: '/schedule-server/provider/business/payout/account/detail' });

export const editBillingPolicy = (data: BillingPolicy[]) => Request.post({ url: '/schedule-server/provider/appointment/policy/update', params: data });

export const editConsentForm = (data: ConsentForm[]) => Request.post({ url: '/schedule-server/provider/consent/form/update', params: data });

export const editPracticeProfile = (data: ApiPracticeProfile) => Request.put({ url: '/schedule-server/provider/profile/update', params: data });

export const editBusinessInfo = (data: BusinessInfo) => Request.post({ url: '/schedule-server/provider/business/info/update', params: data });

export const editPayoutAccount = (data: PayoutAccount) => Request.post({ url: '/schedule-server/provider/business/payout/account/update', params: data });

export const getAccountConnectSecret = () => Request.post({ url: '/schedule-server/provider/connect/account/create/session' });

export const confirmAccountConnect = () => Request.post({ url: '/schedule-server/provider/connect/account/confirm' });

export const editBillingPolicyByOps = (data: BillingPolicy[], providerId: number) => Request.post({ url: `/admin-server/provider/appointment/policy/update/${providerId}`, params: data });

export const editConsentFormByOps = (data: ConsentForm[], providerId: number) => Request.post({ url: `/admin-server/provider/consent/form/update/${providerId}`, params: data });
